import { useEffect } from 'react';
import Accordion from './Accordion';

interface ListDataProps {
  tabValue: number;
  openIndices: number[];
  setOpenIndices: React.Dispatch<React.SetStateAction<number[]>>;
  handleToggle: (index: number) => void;
  dayPartDishList: any[];
  kitchenSectionCode: string;
  searchTerm: string;
}

const ListData: React.FC<ListDataProps> = ({ 
  tabValue, 
  openIndices, 
  setOpenIndices, 
  handleToggle, 
  dayPartDishList, 
  searchTerm 
}) => {
  
  useEffect(() => {
    if (searchTerm.trim().length) {
      const filteredIndices = dayPartDishList
        .map((dish, index) => dish.disheslist?.some((d: any) => d.name.toLowerCase().includes(searchTerm.toLowerCase())) ? index : -1)
        .filter(index => index !== -1);

      setOpenIndices(filteredIndices);
    } else {
      setOpenIndices([0]); 
    }
  }, [searchTerm, tabValue, dayPartDishList]);

  return (
    <>
      {dayPartDishList.length > 0 ? (
        dayPartDishList.map((dayPartDish, dayPartIndex) => (
          <Accordion
            key={dayPartIndex}
            tabValue={tabValue}
            openIndices={openIndices}
            setOpenIndices={setOpenIndices}
            handleToggle={handleToggle}
            dayPartIndex={dayPartIndex}
            dayPartDish={dayPartDish}
            searchTerm={searchTerm}
          />
        ))
      ) : (
        <div className="noData">No data found</div>
      )}
    </>
  );
};

export default ListData;
